import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MultiLanguageService } from "@share/translate";

@Component({
    selector: 'app-share-popup',
    templateUrl: './share-popup.component.html',
    styleUrls: ['./share-popup.component.scss'],
    standalone: false,

})
export class SharePopupComponent {
constructor(private translate:MultiLanguageService) {
}
}
